import moment, { Moment } from "moment";

export interface IUserAccount {
  _id: string;
  username: string;
  created: string;
}

export default class UserAccount {
  _id: string;
  username: string;
  created: Moment;

  constructor(obj: IUserAccount) {
    Object.assign(this, obj);
    this.created = moment(obj.created);
  }
}
